export const normalizePhone = phone => {
  if (typeof phone === 'string') {
    const formatedPhone = Number(phone.replace(/[{()}-]/g, ''));
    return formatedPhone;
  }
  return phone;
};

export default normalizePhone;
